export default "__VITE_PUBLIC_ASSET__510f95be__"